import type { Application, ApplicationWithStats } from '@owl/shared';

export type AppHealth = 'ok' | 'warn' | 'down' | 'idle';

const WARN_MS = 10 * 60_000; // 10 min silence → warn
const DOWN_MS = 60 * 60_000; // 1h silence → down

export function computeAppHealth(app: Pick<Application, 'status' | 'lastLogAt'>): AppHealth {
  if (app.status !== 'active') return 'idle';
  if (!app.lastLogAt) return 'down';
  const ageMs = Date.now() - new Date(app.lastLogAt).getTime();
  if (ageMs >= DOWN_MS) return 'down';
  if (ageMs >= WARN_MS) return 'warn';
  return 'ok';
}

export function aggregateAppsHealth(
  apps: Array<Pick<ApplicationWithStats, 'status' | 'lastLogAt'>>,
): { worst: AppHealth; downCount: number; warnCount: number } {
  let downCount = 0;
  let warnCount = 0;
  for (const a of apps) {
    const h = computeAppHealth(a);
    if (h === 'down') downCount += 1;
    else if (h === 'warn') warnCount += 1;
  }
  const worst: AppHealth = downCount > 0 ? 'down' : warnCount > 0 ? 'warn' : 'ok';
  return { worst, downCount, warnCount };
}
